import Marquee from "react-fast-marquee";

export default function Ribbon({ dark = false }) {
  const words = ["Salt & Stone", "Hydra Island", "Guided Hikes", "Sea & Summit", "Saronic Gulf", "Est. on the mountain"];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${dark ? "border-paper/10 bg-deep text-paper/70" : "border-ink/10 bg-terra text-paper"}`}
    >
      <Marquee speed={28} gradient={false}>
        {words.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-serif text-xl italic tracking-wide sm:text-2xl">
            {w} <span className={`not-italic text-sm ${dark ? "text-terra-light" : "text-paper/60"}`}>✺</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
